module.exports = __webpack_public_path__ + "img/storage4.8c951fa4.png";